import { useSelector } from "react-redux";
import { StoreType } from "../../../core/store/reducers";
import { OrderIndStatuses } from "../../models";

const renderLabel = (item?: OrderIndStatuses) => (item ? item.ftDescr : "");


export const useOrderIndStatusTypes = () => {
  const orderIndtatus = useSelector<StoreType, OrderIndStatuses[]>(
    (store) => store.data.initialData.orderIndStatuses
  );

  return [orderIndtatus, renderLabel] as [typeof orderIndtatus, typeof renderLabel];
};
